module.exports = __webpack_public_path__ + "src/components/Article/kolV.png?331d2fb9";


//////////////////
// WEBPACK FOOTER
// ./src/components/Article/kolV.png
// module id = 2782
// module chunks = 1